import axios from 'axios'

// const isLocalhostOrUAT = ((window.location.href.indexOf('localhost') > -1) || (window.location.href.indexOf('sojournenid-223502') > -1))
const isLocalhost = window.location.href.indexOf('localhost') > -1
const baseUrl = '/stripe'
const gaTrackingId = 'UA-55871638-3'
const pubApiKey = isLocalhost ? 'pk_test_CZVvE1iPMuN847NrJDmuC0SJ' : 'pk_live_AKutuNHsSTQbyWTZRdrpGvDX'
// console.log(pubApiKey)

const getProductPlansPrices = async () => {
    let res = await axios.get(`${baseUrl}/products`)
  
    let productsWithPlansPrices = res.data.data.filter((product) => {
      return ((product.active === true) && (product.type === "service"))
    }).map(async (product) => {

      let prices = await getPricesByProduct(product)
      let active_prices = prices.filter((price) => {
        return ((price.id.indexOf('price_') === 0) && (price.active))
      })
      active_prices.push({ id:'price_configNeeded' }) //default to indicate missing config
      let active_plans = prices.filter((price) => {
        return ((price.id.indexOf('plan_') === 0) && (price.active))
      })
      active_plans.push({ id:'plan_configNeeded' }) //default to indicate missing config

      return {
        productId: product.id,
        productName: product.name,
        planId: active_plans[0].id,
        priceId: active_prices[0].id
      }
    })

    return Promise.all(productsWithPlansPrices)
}

const getPricesByProduct = async (product) => {
  let res = await axios.get(`${baseUrl}/prices/${product.id}`)
  return res.data.data
}

const searchCustomersByCard = async (searchParams) => {
    let results = await axios.post(
      `${baseUrl}/customers/byCard`, searchParams)
    return results.data
}

const removeSubscription = async (subscriptionId) => {
  let results = await axios.delete(
    `${baseUrl}/customers/${subscriptionId}`)
  console.log(results)
  return results
}

export default {
  baseUrl,
  gaTrackingId,
  pubApiKey,

  getProductPlansPrices,
  // getPlansByProduct,
  searchCustomersByCard,
  removeSubscription
}
